/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ source: NonNullable<unknown> }} Import_DetectedInputs */

const en_import_detected = /** @type {(inputs: Import_DetectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.source} link`)
};

const de_import_detected = /** @type {(inputs: Import_DetectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.source}-Link`)
};

/**
* | output |
* | --- |
* | "{source} link" |
*
* @param {Import_DetectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_detected = /** @type {((inputs: Import_DetectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_DetectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_detected(inputs)
	return en_import_detected(inputs)
});